import React, { useState, useRef } from "react";
import { Col, Form, Row, Tab, Tabs, Modal, Table } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Delete from "../../../Components/Modals/DeleteModal";
import Navbar from "../../../Components/Navbar/Navbar";
import TableTemp from "../../../Components/TableTemplate/Table";
import AdjustmentTable from "./../../Inventory/Adjustment/AdjustmentTable";
import NoDataImg from "../../../Assets/Images/no-data-img.png"
import {
    dateFormat,
    formatDateNoTime,
    formatDate,
    numberFormat,
    refreshPage,
    toastStyle,
    getTodayDate,
    getType,
    TokenExpiry,
    getTodayDateISO
} from "../../../Helpers/Utils/Common"; 
import DatePicker from "react-datepicker";
import { Fragment } from "react";
import Moment from "moment";
import InputError from "../../../Components/InputError/InputError";
import { validatePayrollMultipleModal, validatePayrollEmployeeModal } from './../../../Helpers/Validation/Employees/PayrollValidation';
import { CSVLink, CSVDownload } from "react-csv";
import downloadIcon from "../../../Assets/Images/download_icon.png";
import signature from "./../../../Assets/Images/signature.png";
import * as XLSX from "xlsx";

import { getAllBanks } from "../../../Helpers/apiCalls/banksAPi";
import { getAllEmployees, getAllEmployeesWOutPayroll } from "../../../Helpers/apiCalls/employeesApi";
import { getAllPayroll, deletePayroll, printPayroll } from './../../../Helpers/apiCalls/Employees/PayrollApi';
import CashAdvanceModal from './../CashAdvance/CashAdvanceModal';
import Footer from "../../../Components/Footer/Footer";

export default function MultiplePayroll() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const [filterConfig, setFilterConfig] = useState({
        employee_id: "",
        employee_name: "",
        employee_name: "",
        date_from: new Date(),
        date_to: new Date(),
        status: "unprinted",
        user: accountType,
    })
    const [isError, setIsError] = useState({
        employee_type: false,
        date_from: false,
        date_to: false,
        disbursement_date: false,
        employees: false,
    });
    // const [branches, setBranches] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [employeesWOutPayroll, setEmployeesWOutPayroll] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [allData, setAllData] = useState([]);
    const [allDataCsv, setAllDataCsv] = useState([]);
    const [totalNet, setTotalNet] = useState("0");
    const [selectedTab, setSelectedTab] = useState("submitted");
    const [dailySales, setDailySales] = useState([]);
    const [isClicked, setIsClicked] = useState(false);
    const [fetchTableData, setfetchTableData] = useState(false);
    const [payrollDetails, setPayrollDetails] = useState({
        date_from: new Date(),
        date_to: new Date(),
        disbursement_date: new Date(),
    })
    const [selectedEmployees, setSelectedEmployees] = useState([]);

     /* delete modal handler */
     const [showDeleteModal, setShowDeleteModal] = useState(false);
     const handleShowDeleteModal = () => setShowDeleteModal(true);
     const handleCloseDeleteModal = () => setShowDeleteModal(false); 
     /* add modal handler */
     const [showAddModal, setShowAddModal] = useState(false);
     const handleShowAddModal = () => setShowAddModal(true);
     const handleCloseAddModal = () => {
        setShowAddModal(false);
        setPayrollDetails({})
    } 

     const [showEmployeeModal, setShowEmployeeModal] = useState(false);
     const handleShowEmployeeModal = () => setShowEmployeeModal(true);
     const handleCloseEmployeeModal = () => setShowEmployeeModal(false); 

     const [showPrintModal, setShowPrintModal] = useState(false);
     const handleShowPrintModal = () => setShowPrintModal(true);
     const handleClosePrintModal = () => setShowPrintModal(false);

     const [selectedRow, setSelectedRow] = useState([]);
     const [selectedMonthFrom, setSelectedMonthFrom] = useState("");
     const [selectedMonthTo, setSelectedMonthTo] = useState("");
     const today = Moment().format("MM/DD/YYYY");
     const [checkedPayroll, setCheckedPayroll] = useState([]);
    

     const xlsxHeaders =  [ "Payroll Range", "Disbursement Date", "Type", "Employee Name", "Department", "Payee ID", "Net Pay", "Total Working Hours", "Overtime Hours", "Overtime Pay", "Rate", 
            "Basic Pay", "Gross Basic Pay", "Other Wages", "Other Deductions", "Rent", "Total Wages", "Total Deductions", "Transportation Allowance", "Other Allowances", "Holiday", "Philhealth", "SSS", "Pagibig", 
            "Shortage", "Cash Advance", "SSS Loan", "Pagibig Loan", "Remarks" ]
                            
    const excelHeaders = [
        { label: "Payroll Range", key: "payroll_range" },
        { label: "Disbursement Date", key: "disbursement_date" },
        { label: "Type", key: "disbursement_type" },
        { label: "Employee Name", key: "employee_name" },
        { label: "Department", key: "department_name" },
        { label: "Payee ID", key: "payee_id" },
        { label: "Net Pay", key: "grand_total" },
        { label: "Total Working Hours", key: "working_hours" },
        { label: "Rate", key: "rate" },
        { label: "Basic Pay", key: "basic_pay" },
        { label: "Total Wages", key: "total_addition" },
        { label: "Total Deductions", key: "total_deduction" },
        { label: "Transportation Allowance", key: "transportation_allowance" },
        { label: "Other Allowances", key: "other_allowances" },
        { label: "Holiday", key: "holidays" },
        { label: "Other Wages", key: "other_wages" },
        { label: "Philhealth", key: "philhealth" },
        { label: "SSS", key: "sss" },
        { label: "Pagibig", key: "pagibig" },
        { label: "Shortage", key: "shortage" },
        { label: "Cash Advance", key: "cash_advance" },
        { label: "Other Deductions", key: "other_deductions" },
        { label: "SSS Loan", key: "sss_loan" },
        { label: "Pagibig Loan", key: "pagibig_loan" },
        { label: "Remarks", key: "remarks" },
    ];

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    function handleAddModal(e) {
        if(validatePayrollEmployeeModal(selectedEmployees, setIsError)) {
            var ids = selectedEmployees.map((data) => {
                return data.id
            })
            navigate("/payroll/add/multiple", {
                    state: { selectedEmployees: selectedEmployees, 
                            ids: ids, 
                            date_from: payrollDetails.date_from, 
                            date_to: payrollDetails.date_to,
                            disbursement_date: payrollDetails.disbursement_date  },
                }
            )
            // navigate(
            //     `/payroll/add/${selectedEmployee.value}`, {
            //         state: { selectedEmployee: selectedEmployee, date_from: selectedMonthFrom, date_to: selectedMonthTo  },
            //     }
            // )
        }
    }

    function handleSelectChange(e, row) {
        setSelectedRow(row);

        if (e.target.value === "view") {
            window.open("/payroll/view/" + row.id)
            // navigate("/payroll/view/" + row.id, {
            //     state: { date_from: row.date_from, date_to: row.date_to  },
            // })
        } else if (e.target.value === "edit") {
            navigate("/payroll/edit/" + row.id, {
                state: { date_from: row.date_from, date_to: row.date_to  },
            })
        } else if (e.target.value === "delete") {
            handleShowDeleteModal();
        }
    }


    function ActionBtn(row, type) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action"
                onChange={(e) => handleSelectChange(e, row)}
            >
                <option value="" hidden selected>
                    Select
                </option>
                <option value="view" className="color-options">
                    View
                </option>
                {/* <option value="edit" className="color-options">
                    Edit
                </option> */}
                {(((accountType === "admin" || accountType === "hr_officer") && (row.status !== "printed")) || (accountType === "admin" && row.status === "printed")) && (
                    <option value="delete" className="color-red">
                        Delete
                    </option>
                )}
            </Form.Select>
        );
    }

    function ViewBtn(row) {
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => window.open("/payroll/view/" + row.id)}
            >
                View
            </button>
        );
    }

    function Print() {
        let printContents = document.getElementById("printablediv").innerHTML;
        let originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print(printContents);
        document.body.innerHTML = originalContents;
        refreshPage()
    }

    async function handlePrintPI() {
        toast.loading("Printing Details", { style: toastStyle() });
        handleClosePrintModal();
        setTimeout(() => {
            toast.dismiss();
            handlePrintStatus()
            Print();
        }, 1000);
    }

    async function fetchEmployees() {
        setEmployeesWOutPayroll([])
        if(validatePayrollMultipleModal(payrollDetails, setIsError)){
            const response = await getAllEmployeesWOutPayroll(payrollDetails);
            // const response = await getAllEmployeesWOutPayroll(payrollDetails);
            if (response.error) {
                setEmployeesWOutPayroll([])
                toast.error(response.error.data?.messages.error, {
                    style: toastStyle(),
                });
            } else {
                let result = response.data.data.map((data) => {
                    var employee = data;
                    employee.label = data.first_name + " " + data.last_name;
                    employee.value = data.id;
                    return employee;
                });
                setEmployeesWOutPayroll(result);
                handleShowEmployeeModal();
            }
        } 
    }

    async function fetchEmployeesInitial() {
        // if(validatePayrollMultipleModal(payrollDetails, setIsError)){
            setEmployees([])
            const response = await getAllEmployees();
            // const response = await getAllEmployeesWOutPayroll(payrollDetails);
            if (response.error) {
                setEmployees([])
                toast.error(response.error.data?.messages.error, {
                    style: toastStyle(),
                });
            } else {
                let result = response.data.data.map((data) => {
                    var employee = data;
                    employee.label = data.first_name + " " + data.last_name;
                    employee.value = data.id;
                    return employee;
                });
                result.unshift({id:null, label:"All Employees", value:""})
                setEmployees(result);
            }
        // }
    }

    async function fetchData() {
        setShowLoader(true);
        setAllData([])
        setTotalNet("0")

        const response = await getAllPayroll(filterConfig);
        // 
        if (response.error) {
            setAllData([])
        } else {
            if(filterConfig.user === "admin") {
                var total = response.data.summary? response.data.summary.total_net : "0";
                setTotalNet(total);

                var allBills = response.data.data.map((bill) => {
                    var info = bill;
                    info.month = dateFormat(bill.date_from) + " - " + dateFormat(bill.date_to);
                    info.payroll_range = Moment(bill.date_from).format("MMM DD, YYYY") + " to " + Moment(bill.date_to).format("MMM DD, YYYY");
                    info.disbursement_date = Moment(bill.disbursement_date).format("MMM DD, YYYY");
                    info.grand_total = numberFormat(bill.grand_total);
                    info.payee_id = (bill.payee_id !== "null" && bill.payee_id !== "undefined") ? bill.payee_id : ""
                    return info;
                });
                setAllData(allBills)
    
                // var csv = response.data.admin_generated_payroll.map((bill) => {
                var csv = response.data.data.map((bill) => {
                    var info = {};
                    info.payroll_range = Moment(bill.date_from).format("MMM DD, YYYY") + " to " + Moment(bill.date_to).format("MMM DD, YYYY");
                    info.disbursement_date = Moment(bill.disbursement_date).format("MMM DD, YYYY");
                    info.disbursement_type = bill.disbursement_type;
                    info.employee_name = bill.employee_name;
                    info.department_name = bill.department_name;
                    info.payee_id = (bill.payee_id !== "null" && bill.payee_id !== "undefined") ? bill.payee_id : ""
                    info.grand_total = (bill.grand_total);
                    info.working_hours = (bill.working_hours);
                    info.overtime_hours = numberFormat(bill.overtime_hours);
                    info.overtime_pay = numberFormat(bill.overtime_pay);
                    info.rate = numberFormat(bill.rate);
                    info.basic_pay = numberFormat(bill.basic_pay);
                    info.gross_pay = numberFormat(bill.gross_pay);
                    info.other_wages = numberFormat(bill.other_wages);
                    info.other_deductions = numberFormat(bill.other_deductions);
                    info.rent = numberFormat(bill.rent);
                    info.total_addition = numberFormat(bill.total_addition);
                    info.total_deduction = numberFormat(bill.total_deduction);
                    info.transportation_allowance = numberFormat(bill.transportation_allowance);
                    info.other_allowances = numberFormat(bill.other_allowances);
                    info.holidays = numberFormat(bill.holidays);
                    info.philhealth = numberFormat(bill.philhealth);
                    info.sss = numberFormat(bill.sss);
                    info.pagibig = numberFormat(bill.pagibig);
                    info.shortage = numberFormat(bill.shortage);
                    info.cash_advance = numberFormat(bill.cash_advance);
                    info.sss_loan = numberFormat(bill.sss_loan);
                    info.pagibig_loan = numberFormat(bill.pagibig_loan);
                    info.remarks = bill.remarks;
                    return info;
                });
                var totalNet = {
                    payroll_range: "",
                    disbursement_date: "",
                    disbursement_type: "",
                    employee_name: "",
                    department_name: "",
                    payee_id: "",
                    grand_total: numberFormat(total),
                    working_hours: response.data.summary?.working_hours_sum ? numberFormat(response.data.summary.working_hours_sum) : "",
                    overtime_hours: response.data.summary?.overtime_hours_sum ? numberFormat(response.data.summary.overtime_hours_sum) : "",
                    overtime_pay: response.data.summary?.overtime_pay_sum ? numberFormat(response.data.summary.overtime_pay_sum) : "",
                    rate: response.data.summary?.rate_sum ? numberFormat(response.data.summary.rate_sum) : "",
                    basic_pay: response.data.summary?.basic_pay_sum ? numberFormat(response.data.summary.basic_pay_sum) : "",
                    gross_pay: response.data.summary?.gross_pay_sum ? numberFormat(response.data.summary.gross_pay_sum) : "",
                    other_wages: response.data.summary?.other_wages_sum ? numberFormat(response.data.summary.other_wages_sum) : "",
                    other_deductions: response.data.summary?.other_deductions_sum ? numberFormat(response.data.summary.other_deductions_sum) : "",
                    rent: response.data.summary?.rent_sum ? numberFormat(response.data.summary.rent_sum) : "",
                    total_addition: response.data.summary?.total_addition_sum ? numberFormat(response.data.summary.total_addition_sum) : "",
                    total_deduction: response.data.summary?.total_deduction_sum ? numberFormat(response.data.summary.total_deduction_sum) : "",
                    transportation_allowance: response.data.summary?.transportation_allowance_sum ? numberFormat(response.data.summary.transportation_allowance_sum) : "",
                    other_allowances: response.data.summary?.other_allowances_sum ? numberFormat(response.data.summary.other_allowances_sum) : "",
                    holidays: response.data.summary?.holidays_sum ? numberFormat(response.data.summary.holidays_sum) : "",
                    philhealth: response.data.summary?.philhealth_sum ? numberFormat(response.data.summary.philhealth_sum) : "",
                    sss: response.data.summary?.sss_sum ? numberFormat(response.data.summary.sss_sum) : "",
                    pagibig: response.data.summary?.pagibig_sum ? numberFormat(response.data.summary.pagibig_sum) : "",
                    shortage: response.data.summary?.shortage_sum ? numberFormat(response.data.summary.shortage_sum) : "",
                    cash_advance: response.data.summary?.cash_advance_sum ? numberFormat(response.data.summary.cash_advance_sum) : "",
                    sss_loan: response.data.summary?.sss_loan_sum ? numberFormat(response.data.summary.sss_loan_sum) : "",
                    pagibig_loan: response.data.summary?.pagibig_loan_sum ? numberFormat(response.data.summary.pagibig_loan_sum) : "",
                    remarks: "",
                };
                var newCsv = [...csv, totalNet]
                setAllDataCsv(newCsv)

            } else {
                var total = response.data.summary? response.data.summary.total_net : "0";
                setTotalNet(total);

                var allBills = response.data.data.map((bill) => {
                    var info = bill;
                    info.month = dateFormat(bill.date_from) + " - " + dateFormat(bill.date_to);
                    info.payroll_range = Moment(bill.date_from).format("MMM DD, YYYY") + " to " + Moment(bill.date_to).format("MMM DD, YYYY");
                    info.disbursement_date = Moment(bill.disbursement_date).format("MMM DD, YYYY");
                    info.grand_total = numberFormat(bill.grand_total);
                    info.payee_id = (bill.payee_id !== "null" && bill.payee_id !== "undefined") ? bill.payee_id : ""
                    return info;
                });
                setAllData(allBills)

                var csv = response.data.data.map((bill) => {
                    var info = {};
                    info.payroll_range = Moment(bill.date_from).format("MMM DD, YYYY") + " to " + Moment(bill.date_to).format("MMM DD, YYYY");
                    info.disbursement_date = Moment(bill.disbursement_date).format("MMM DD, YYYY");
                    info.disbursement_type = bill.disbursement_type;
                    info.employee_name = bill.employee_name;
                    info.department_name = bill.department_name;
                    info.payee_id = (bill.payee_id !== "null" && bill.payee_id !== "undefined") ? bill.payee_id : ""
                    info.grand_total = (bill.grand_total);
                    info.working_hours = numberFormat(bill.working_hours);
                    info.overtime_hours = numberFormat(bill.overtime_hours);
                    info.overtime_pay = numberFormat(bill.overtime_pay);
                    info.rate = numberFormat(bill.rate);
                    info.basic_pay = numberFormat(bill.basic_pay);
                    info.gross_pay = numberFormat(bill.gross_pay);
                    info.other_wages = numberFormat(bill.other_wages);
                    info.other_deductions = numberFormat(bill.other_deductions);
                    info.rent = numberFormat(bill.rent);
                    info.total_addition = numberFormat(bill.total_addition);
                    info.total_deduction = numberFormat(bill.total_deduction);
                    info.transportation_allowance = numberFormat(bill.transportation_allowance);
                    info.other_allowances = numberFormat(bill.other_allowances);
                    info.holidays = numberFormat(bill.holidays);
                    info.philhealth = numberFormat(bill.philhealth);
                    info.sss = numberFormat(bill.sss);
                    info.pagibig = numberFormat(bill.pagibig);
                    info.shortage = numberFormat(bill.shortage);
                    info.cash_advance = numberFormat(bill.cash_advance);
                    info.sss_loan = numberFormat(bill.sss_loan);
                    info.pagibig_loan = numberFormat(bill.pagibig_loan);
                    info.remarks = bill.remarks;
                    return info;
                });
                var totalNet = {
                    payroll_range: "",
                    disbursement_date: "",
                    disbursement_type: "",
                    employee_name: "",
                    department_name: "",
                    payee_id: "",
                    grand_total: numberFormat(total),
                    working_hours: response.data.summary?.working_hours_sum ? numberFormat(response.data.summary.working_hours_sum) : "",
                    overtime_hours: response.data.summary?.overtime_hours_sum ? numberFormat(response.data.summary.overtime_hours_sum) : "",
                    overtime_pay: response.data.summary?.overtime_pay_sum ? numberFormat(response.data.summary.overtime_pay_sum) : "",
                    rate: response.data.summary?.rate_sum ? numberFormat(response.data.summary.rate_sum) : "",
                    basic_pay: response.data.summary?.basic_pay_sum ? numberFormat(response.data.summary.basic_pay_sum) : "",
                    gross_pay: response.data.summary?.gross_pay_sum ? numberFormat(response.data.summary.gross_pay_sum) : "",
                    other_wages: response.data.summary?.other_wages_sum ? numberFormat(response.data.summary.other_wages_sum) : "",
                    other_deductions: response.data.summary?.other_deductions_sum ? numberFormat(response.data.summary.other_deductions_sum) : "",
                    rent: response.data.summary?.rent_sum ? numberFormat(response.data.summary.rent_sum) : "",
                    total_addition: response.data.summary?.total_addition_sum ? numberFormat(response.data.summary.total_addition_sum) : "",
                    total_deduction: response.data.summary?.total_deduction_sum ? numberFormat(response.data.summary.total_deduction_sum) : "",
                    transportation_allowance: response.data.summary?.transportation_allowance_sum ? numberFormat(response.data.summary.transportation_allowance_sum) : "",
                    other_allowances: response.data.summary?.other_allowances_sum ? numberFormat(response.data.summary.other_allowances_sum) : "",
                    holidays: response.data.summary?.holidays_sum ? numberFormat(response.data.summary.holidays_sum) : "",
                    philhealth: response.data.summary?.philhealth_sum ? numberFormat(response.data.summary.philhealth_sum) : "",
                    sss: response.data.summary?.sss_sum ? numberFormat(response.data.summary.sss_sum) : "",
                    pagibig: response.data.summary?.pagibig_sum ? numberFormat(response.data.summary.pagibig_sum) : "",
                    shortage: response.data.summary?.shortage_sum ? numberFormat(response.data.summary.shortage_sum) : "",
                    cash_advance: response.data.summary?.cash_advance_sum ? numberFormat(response.data.summary.cash_advance_sum) : "",
                    sss_loan: response.data.summary?.sss_loan_sum ? numberFormat(response.data.summary.sss_loan_sum) : "",
                    pagibig_loan: response.data.summary?.pagibig_loan_sum ? numberFormat(response.data.summary.pagibig_loan_sum) : "",
                    remarks: "",
                };
                var newCsv = [...csv, totalNet]
                setAllDataCsv(newCsv)
            }

        }
        setShowLoader(false);
    }
    // 

    async function handlePrintStatus() {
        setIsClicked(true);
        const response = await printPayroll(checkedPayroll);
        if (response.data) {
            // 
        } else {
            toast.error("Error changing status to print", {
                style: toastStyle(),
            });
        }
    }

    async function handleDeleteExpense() {
        setIsClicked(true);
        const response = await deletePayroll(selectedRow.id);
        if (response.data) {
            toast.success("Payroll Deleted Successfully!", {
                style: toastStyle(),
            });
            setTimeout(() => refreshPage(), 1000);
        } else {
            toast.error("Error Deleting Payroll", {
                style: toastStyle(),
            });
        }
    }

    const handlePayrollChange = (e, type) => {
        const { name, value } = e.target;
        setPayrollDetails((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    }
    
    function handleOnCheck(row) {
        setCheckedPayroll(row.selectedRows);
    }

    const handleTabSelect = (tabKey) => {
        setFilterConfig((prev) => {
            return { ...prev, 
                status: tabKey,
                employee_type: "",
                disbursement_type: "",
                employee_id: "",
                // date_from: "",
                // date_to: "",
             };
        });
    };

    function renderTable(data) {
        return (
            <Table className="ps-table">
                <thead>
                    <tr>
                        <th className="text-start">Employee Info</th>
                    </tr>
                </thead>
                <tbody>
                    <tr >
                        <td className="franchise-td-gray text-start bolder req-table-w-border-left">Name</td>
                        <td className="franchise-td-gray text-end">{data.employee_name}</td>
                        
                        <td className="franchise-td-gray text-start bolder req-table-w-border-left">Rate</td>
                        <td className="franchise-td-gray text-end">{numberFormat(data.rate)}</td>

                        <td className="franchise-td-gray text-start bolder req-table-w-border-left">Disbursement Type</td>
                        <td className="franchise-td-gray text-end req-table-w-border-right">{data.disbursement_type?.toUpperCase()}</td>
                    </tr>
                    {
                        (data.employee_type !== "department head") && (
                            <>
                                <tr >
                                    <td className="franchise-td-gray text-start bolder req-table-w-border-left">Scheduled Work Days</td>
                                    <td className="franchise-td-gray text-end">{data.scheduled_work_days ? numberFormat(data.scheduled_work_days) : 0}</td>
                                    {
                                        parseInt(data.scheduled_work_days) !== 0 && (
                                            <>
                                            <td className="franchise-td-gray text-start bolder req-table-w-border-left">Worked Days</td>
                                            <td className="franchise-td-gray text-end">{data.working_days ? numberFormat(data.working_days) : 0}</td>
                                            
                                            <td className="franchise-td-gray text-start bolder req-table-w-border-left">Absent</td>
                                            <td className="franchise-td-gray text-end req-table-w-border-right">{data.absences ? numberFormat(data.absences) : 0}</td>
                                            </>
                                        )
                                    }
                                    {
                                        parseInt(data.scheduled_work_days) === 0 && (
                                            <>
                                            <td className="franchise-td-gray text-start bolder req-table-w-border-left">Worked Hours</td>
                                            <td className="franchise-td-gray text-end req-table-w-border-right">{data.working_hours ? numberFormat(data.working_hours) : 0}</td>
                                            </>
                                        )
                                    }
                                </tr>
                                <tr >
                                    {
                                        parseInt(data.scheduled_work_days) !== 0 && (
                                            <>
                                            <td className="franchise-td-gray text-start bolder req-table-w-border-left">Worked Hours</td>
                                            <td className="franchise-td-gray text-end">{data.working_hours ? numberFormat(data.working_hours) : 0}</td>

                                            <td className="franchise-td-gray text-start bolder req-table-w-border-left">Undertime</td>
                                            <td className="franchise-td-gray text-end">{data.undertime_hours ? numberFormat(data.undertime_hours) : 0}</td>
                                            
                                            <td className="franchise-td-gray text-start bolder req-table-w-border-left">Overtime</td>
                                            <td className="franchise-td-gray text-end req-table-w-border-right">{data.overtime_hours ? numberFormat(data.overtime_hours) : 0}</td>
                                            </>
                                        )
                                    }
                                </tr>
                            </>
                        )
                    }
                </tbody>
            </Table>
        );
    }
    
    function renderTableEarnings(data) {
        return (
            <Table className="ps-table">
                <thead>
                    <tr>
                        <th className="text-start">Wages</th>
                        <th className="text-end">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="franchise-td-gray text-start">Basic Pay</td>
                        <td className="franchise-td-gray text-end">{numberFormat(data.basic_pay)}</td>
                    </tr>
                    {
                        parseInt(data.transportation_allowance) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">Transportation Allowance</td>
                                <td className="franchise-td-gray text-end">{numberFormat(data.transportation_allowance)}</td>
                            </tr>
                        )
                    }
                    {
                        parseInt(data.other_allowances) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">Other Allowances</td>
                                <td className="franchise-td-gray text-end">{numberFormat(data.other_allowances)}</td>
                            </tr>
                        )
                    }
                    {
                        parseInt(data.holidays) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">Holidays</td>
                                <td className="franchise-td-gray text-end">{numberFormat(data.holidays)}</td>
                            </tr>
                        )
                    }
                    {
                        parseInt(data.thirteenth_month) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">13th Month</td>
                                <td className="franchise-td-gray text-end">{numberFormat(data.thirteenth_month)}</td>
                            </tr>
                        )
                    }
                    {
                        parseInt(data.bonus) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">Bonus</td>
                                <td className="franchise-td-gray text-end">{numberFormat(data.bonus)}</td>
                            </tr>
                        )
                    }
                    {
                        parseInt(data.service_incentive) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">Service Incentive</td>
                                <td className="franchise-td-gray text-end">{numberFormat(data.service_incentive)}</td>
                            </tr>
                        )
                    }
                    {
                        parseInt(data.other_wages) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">{data.other_wages_description}</td>
                                <td className="franchise-td-gray text-end">{(data.other_wages !== null && parseInt(data.other_wages) !== 0) ? numberFormat(data.other_wages) : ""}</td>
                            </tr>
                        )
                    }
                    {
                        (data.overtime_pay && parseInt(data.overtime_pay) !== 0) && (
                            <tr>
                                <td className="franchise-td-gray text-start">Overtime Pay {" "}</td>
                                <td className="franchise-td-gray text-end">{(data.overtime_pay !== null && parseInt(data.overtime_pay) !== 0) ? numberFormat(data.overtime_pay) : ""}</td>
                            </tr>
                        )
                    }
                    <tr className="req-table-w-border-top">
                        <td className="franchise-td-gray text-start">Gross Wages</td>
                        <td className="franchise-td-gray green text-end">{numberFormat(parseFloat(data.total_addition) + parseFloat(data.basic_pay) + parseFloat(data.overtime_pay))}</td>
                    </tr>
                    <tr>
                        <td className="franchise-td-gray text-start">Total Deductions</td>
                        <td className="franchise-td-gray red text-end">-{numberFormat(data.total_deduction)}</td>
                    </tr>
                    <tr>
                        <td className="franchise-td-gray-last text-start bolder green bigger">Net Pay</td>
                        <td className="franchise-td-gray-last green text-end bigger">{data.grand_total}</td>
                    </tr>
                </tbody>
            </Table>
        );
    }
    
    function renderTableDeductions(data) {
        return (
            <Table className="ps-table">
                <thead>
                    <tr>
                        <th className="text-start">Deductions</th>
                        <th className="text-end">Amount</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        parseInt(data.philhealth) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">PhilHealth</td>
                                <td className="franchise-td-gray text-end">{numberFormat(data.philhealth)}</td>
                            </tr>
                        )
                    }
                    {
                        parseInt(data.sss) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">SSS</td>
                                <td className="franchise-td-gray text-end">{numberFormat(data.sss)}</td>
                            </tr>
                        )
                    }
                    {
                        parseInt(data.pagibig) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">Pag-Ibig</td>
                                <td className="franchise-td-gray text-end">{numberFormat(data.pagibig)}</td>
                            </tr>
                        )
                    }
                    {
                        parseInt(data.sss_loan) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">SSS Loan</td>
                                <td className="franchise-td-gray text-end">{numberFormat(data.sss_loan)}</td>
                            </tr>
                        )
                    }
                    {
                        parseInt(data.pagibig_loan) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">Pag-Ibig Loan</td>
                                <td className="franchise-td-gray text-end">{numberFormat(data.pagibig_loan)}</td>
                            </tr>
                        )
                    }
                    {
                        parseInt(data.shortage) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">Total Shortage</td>
                                <td className="franchise-td-gray text-end">{numberFormat(data.shortage)}</td>
                            </tr>
                        )
                    }
                    {
                        data.cash_advances?.map((ca) => {
                            return (
                                <tr>
                                    <td className="franchise-td-gray text-start">{ca.type.split("_")[0] + " " + ca.type.split("_")[1]}</td>
                                    <td className="franchise-td-gray text-end">{numberFormat(ca.amount)}</td>
                                </tr>
                            )
                        })
                    }
                    {
                        parseInt(data.other_deductions) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">{data.other_deductions_description}</td>
                                <td className="franchise-td-gray text-end">{(data.other_deductions !== null && parseInt(data.other_deductions) !== 0) ? numberFormat(data.other_deductions) : ""}</td>
                            </tr>
                        )
                    }
                    {
                        parseInt(data.rent) !== 0 && (
                            <tr>
                                <td className="franchise-td-gray text-start">Rent</td>
                                <td className="franchise-td-gray text-end">{numberFormat(data.rent)}</td>
                            </tr>
                        )
                    }
                    <tr className="req-table-w-border-top">
                        <td className="franchise-td-gray text-start">Total Deductions</td>
                        <td className="franchise-td-gray red text-end">{numberFormat(data.total_deduction)}</td>
                    </tr>
                </tbody>
            </Table>
        );
    }
    
    function handleExport() {
        const rows = allDataCsv
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
        XLSX.writeFile(workbook, "PayrollHistory.xlsx", { compression: true });
    }

    
    // const isInitialMount = useRef(true);
    // const filterConfigKey = 'payroll-filterConfig';
    // React.useEffect(()=>{
    //     if(isInitialMount.current){
    //         isInitialMount.current = false;
    //         
    //         if (window.localStorage.getItem(filterConfigKey) != null){
    //             
    //             handleTabSelect(JSON.parse(window.localStorage.getItem(filterConfigKey)).status);
    //             var info = JSON.parse(window.localStorage.getItem(filterConfigKey))
    //             setFilterConfig(info);
    //             
    //         }
    //     } else {
    //         window.localStorage.setItem(filterConfigKey, JSON.stringify(filterConfig));
    //     }
    // }, [filterConfig])

    const isInitialMount = useRef(true);
    const filterConfigKey = 'payroll-filterConfig';
    React.useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            // 
            const savedFilterConfig = window.localStorage.getItem(filterConfigKey);
            if (savedFilterConfig !== null) {
                // 
                const parsedFilterConfig = JSON.parse(savedFilterConfig);
                handleTabSelect(parsedFilterConfig.status);

                // Parse date strings back to Date objects
                parsedFilterConfig.date_from = new Date(parsedFilterConfig.date_from);
                parsedFilterConfig.date_to = new Date(parsedFilterConfig.date_to);

                setFilterConfig(parsedFilterConfig);
                // 
            }
        } else {
            // Convert date objects to string representations before storing
            const updatedFilterConfig = {
                ...filterConfig,
                date_from: filterConfig.date_from.toISOString(),
                date_to: filterConfig.date_to.toISOString(),
                // date_from: new Date(filterConfig.date_from),
                // date_to: new Date(filterConfig.date_to),
            };
            window.localStorage.setItem(filterConfigKey, JSON.stringify(updatedFilterConfig));
        }
    }, [filterConfig]);
    // 

    React.useEffect(() => {
        fetchEmployeesInitial();
    }, []);

    React.useEffect(() => {
        fetchData();
    }, [filterConfig]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"PAYROLL"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}

                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> PAYROLL HISTORY </h1>
                    </Col>
                    <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            name="employee_name"
                            placeholder="Search employee name"
                            className="search-bar"
                            onChange={handleOnSearch}
                        />
                    </Col>
                    <Col lg={2} className="mt-4 mt-lg-0">
                        <div className="PO-filters">
                        <button
                            className="add-btn"
                            onClick={(e) => handleShowAddModal()}
                        >
                            Add
                        </button>
                        </div>
                    </Col>
                </Row>
                
                <Tabs
                    activeKey={filterConfig.status}
                    id="PO-tabs"
                    className="manager-tabs"
                    onSelect={handleTabSelect}
                >
                    <Tab eventKey="unprinted" title="unprinted">
                        <div className="tab-content">
                            <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Select Employee"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                        borderRadius: "7px",
                                        border: "0px",
                                        minHeight: "20px",
                                        maxHeight: "35px",
                                        }),
                                        input: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: state.isSelected? "white": "white",
                                            
                                        }),
                                        dropdownIndicator: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        singleValue: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        placeholder: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        
                                    }}
                                    value={{
                                        label: filterConfig.employee_name !== "" ? filterConfig.employee_name : "All Employees",
                                        value: filterConfig.employee_id,
                                    }}
                                    options={employees}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                            return { ...prev, 
                                                "employee_id": e.value,
                                                "employee_name": e.label !== "All Employees" ? e.label : ""};
                                        });}}
                                />
                                </Col>
                                <Col xs={6} lg={2} className="mb-1 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Employee Type..."
                                    name="employee_type"
                                    value={filterConfig.employee_type}
                                    onChange={(e) => setFilterConfig((prev) => {
                                        return { ...prev, "employee_type": e.target.value };
                                    })}
                                >
                                    <option value="">All Employee Type</option>
                                    <option value="service crew">Service Crew</option>
                                    <option value="office staff">Office Staff</option>
                                    <option value="department head">Department Head</option>
                                    <option value="driver">Driver</option>
                                    <option value="warehouse staff">Warehouse Staff</option>
                                    <option value="commissary staff">Commissary Staff</option>
                                </Form.Select>
                                </Col>
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Select Type..."
                                    name="disbursement_type"
                                    value={filterConfig.disbursement_type}
                                    onChange={(e) => setFilterConfig((prev) => {
                                        return { ...prev, "disbursement_type": e.target.value };
                                    })}
                                >
                                    <option value="">
                                        All Disbursement Type
                                    </option>
                                    <option value="atm">
                                        ATM deposit
                                    </option>
                                    <option value="palawan">
                                        Palawan
                                    </option>
                                    <option value="cash">
                                        Cash
                                    </option>
                                    <option value="others">
                                        Others
                                    </option>
                                </Form.Select>

                                </Col>
                                <Col xs={6} lg={2}>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_from}
                                    name="date"
                                    placeholderText={"Select Date"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, 
                                                date_from: date, 
                                                date_to: date, 
                                            };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter me-4 form-control py-2"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                                </Col>
                            </Row>
                            <div className="mb-2" />

                            <div className=" PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 mt-2 ps-label">
                                    Total NET: {numberFormat(totalNet)}
                                </span>
                            </div>

                            <div className="below">
                                <AdjustmentTable
                                    tableHeaders={[
                                        "-",
                                        "DISBURSEMENT DATE",
                                        "PAYROLL RANGE",
                                        "TYPE",
                                        "EMPLOYEE NAME",
                                        "PAYEE ID",
                                        "AMOUNT",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "disbursement_date",
                                        "payroll_range",
                                        "disbursement_type",
                                        "employee_name",
                                        "payee_id",
                                        "grand_total",
                                    ]}
                                    tableData={allData}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    handleOnCheck={(row) => handleOnCheck(row)}
                                    showLoader={showLoader}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    <Tab eventKey="printed" title="printed">
                        <div className="tab-content">
                        <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Select Employee"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                        borderRadius: "7px",
                                        border: "0px",
                                        minHeight: "20px",
                                        maxHeight: "35px",
                                        }),
                                        input: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: state.isSelected? "white": "white",
                                            
                                        }),
                                        dropdownIndicator: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        singleValue: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        placeholder: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        
                                    }}
                                    value={{
                                        label: filterConfig.employee_name !== "" ? filterConfig.employee_name : "All Employees",
                                        value: filterConfig.employee_id,
                                    }}
                                    options={employees}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                            return { ...prev, 
                                                "employee_id": e.value,
                                                "employee_name": e.label !== "All Employees" ? e.label : ""};
                                        });}}
                                />
                                </Col>
                                <Col xs={6} lg={2} className="mb-1 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Employee Type..."
                                    name="employee_type"
                                    value={filterConfig.employee_type}
                                    onChange={(e) => setFilterConfig((prev) => {
                                        return { ...prev, "employee_type": e.target.value };
                                    })}
                                >
                                    <option value="">All Employee Type</option>
                                    <option value="service crew">Service Crew</option>
                                    <option value="office staff">Office Staff</option>
                                    <option value="department head">Department Head</option>
                                    <option value="driver">Driver</option>
                                    <option value="warehouse staff">Warehouse Staff</option>
                                    <option value="commissary staff">Commissary Staff</option>
                                </Form.Select>
                                </Col>
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Select Type..."
                                    name="disbursement_type"
                                    value={filterConfig.disbursement_type}
                                    onChange={(e) => setFilterConfig((prev) => {
                                        return { ...prev, "disbursement_type": e.target.value };
                                    })}
                                >
                                    <option value="">
                                        All Disbursement Type
                                    </option>
                                    <option value="atm">
                                        ATM deposit
                                    </option>
                                    <option value="palawan">
                                        Palawan
                                    </option>
                                    <option value="cash">
                                        Cash
                                    </option>
                                    <option value="others">
                                        Others
                                    </option>
                                </Form.Select>

                                </Col>
                                <Col xs={6} lg={2}>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_from}
                                    name="date"
                                    placeholderText={"Select Date"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, 
                                                date_from: date, 
                                                date_to: date, 
                                            };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter me-4 form-control py-2"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                                </Col>
                            </Row>
                            <div className="mb-2" />

                            <div className=" PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 mt-2 ps-label">
                                    Total NET: {numberFormat(totalNet)}
                                </span>
                            </div>

                            <div className="below">
                                <AdjustmentTable
                                    tableHeaders={[
                                        "-",
                                        "DISBURSEMENT DATE",
                                        "PAYROLL RANGE",
                                        "TYPE",
                                        "EMPLOYEE NAME",
                                        "PAYEE ID",
                                        "AMOUNT",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "disbursement_date",
                                        "payroll_range",
                                        "disbursement_type",
                                        "employee_name",
                                        "payee_id",
                                        "grand_total",
                                    ]}
                                    tableData={allData}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    handleOnCheck={(row) => handleOnCheck(row)}
                                    showLoader={showLoader}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                    <Tab eventKey="" title="All">
                        <div className="tab-content">
                        <div className="mb-3" />
                            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                                Filter By:
                            </span>
                            <Row className="PO-filters flex flex-row mx-2 my-1">
                                <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                                <Select
                                    className="dropsearch-filter"
                                    classNamePrefix="react-select"
                                    placeholder="Select Employee"
                                    styles={{
                                        control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        backgroundColor: state.isSelected ? 'white' : 'var(--primary-color)',
                                        borderRadius: "7px",
                                        border: "0px",
                                        minHeight: "20px",
                                        maxHeight: "35px",
                                        }),
                                        input: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: state.isSelected? "white": "white",
                                            
                                        }),
                                        dropdownIndicator: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        singleValue: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        placeholder: (baseStyles, state) => ({
                                            ...baseStyles,
                                            color: "white"
                                            
                                        }),
                                        
                                    }}
                                    value={{
                                        label: filterConfig.employee_name !== "" ? filterConfig.employee_name : "All Employees",
                                        value: filterConfig.employee_id,
                                    }}
                                    options={employees}
                                    onChange={(e) => { setFilterConfig((prev) => {
                                            return { ...prev, 
                                                "employee_id": e.value,
                                                "employee_name": e.label !== "All Employees" ? e.label : ""};
                                        });}}
                                />
                                </Col>
                                <Col xs={6} lg={2} className="mb-1 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Employee Type..."
                                    name="employee_type"
                                    value={filterConfig.employee_type}
                                    onChange={(e) => setFilterConfig((prev) => {
                                        return { ...prev, "employee_type": e.target.value };
                                    })}
                                >
                                    <option value="">All Employee Type</option>
                                    <option value="service crew">Service Crew</option>
                                    <option value="office staff">Office Staff</option>
                                    <option value="department head">Department Head</option>
                                    <option value="driver">Driver</option>
                                    <option value="warehouse staff">Warehouse Staff</option>
                                    <option value="commissary staff">Commissary Staff</option>
                                </Form.Select>
                                </Col>
                                <Col xs={6} lg={2} className="mb-2 mb-lg-0">
                                <Form.Select
                                    type="select"
                                    className="date-filter force-width w-full"
                                    classNamePrefix="react-select"
                                    placeholder="Select Type..."
                                    name="disbursement_type"
                                    value={filterConfig.disbursement_type}
                                    onChange={(e) => setFilterConfig((prev) => {
                                        return { ...prev, "disbursement_type": e.target.value };
                                    })}
                                >
                                    <option value="">
                                        All Disbursement Type
                                    </option>
                                    <option value="atm">
                                        ATM deposit
                                    </option>
                                    <option value="palawan">
                                        Palawan
                                    </option>
                                    <option value="cash">
                                        Cash
                                    </option>
                                    <option value="others">
                                        Others
                                    </option>
                                </Form.Select>

                                </Col>
                                <Col xs={6} lg={2}>
                                <DatePicker
                                    autoComplete="off"
                                    selected={filterConfig.date_from}
                                    name="date"
                                    placeholderText={"Select Date"}
                                    onChange={(date) => {
                                        setFilterConfig((prev) => {
                                            return { ...prev, 
                                                date_from: date, 
                                                date_to: date, 
                                            };
                                        });
                                    }}
                                    fixedHeight
                                    className="date-filter me-4 form-control py-2"
                                    showYearDropdown
                                    dateFormatCalendar="MMMM"
                                    yearDropdownItemNumber={20}
                                    scrollableYearDropdown
                                />
                                </Col>
                            </Row>
                            <div className="mb-2" />

                            <div className=" PO-filters d-flex justify-content-center">
                                <span className="me-4 ml-4 mt-2 ps-label">
                                    Total NET: {numberFormat(totalNet)}
                                </span>
                            </div>

                            <div className="below">
                                <TableTemp
                                    tableHeaders={[
                                        "-",
                                        "DISBURSEMENT DATE",
                                        "PAYROLL RANGE",
                                        "TYPE",
                                        "EMPLOYEE NAME",
                                        "PAYEE ID",
                                        "AMOUNT",
                                        "ACTIONS",
                                    ]}
                                    headerSelector={[
                                        "-",
                                        "disbursement_date",
                                        "payroll_range",
                                        "disbursement_type",
                                        "employee_name",
                                        "payee_id",
                                        "grand_total",
                                    ]}
                                    tableData={allData}
                                    ActionBtn={(row) => ActionBtn(row)}
                                    ViewBtn={(row) => ViewBtn(row)}
                                    handleOnCheck={(row) => handleOnCheck(row)}
                                    showLoader={showLoader}
                                />
                            </div>
                            <div className="mb-2" />
                        </div>
                    </Tab>
                </Tabs>
                {
                    (checkedPayroll.length > 0 && (filterConfig.status === "unprinted" || filterConfig.status === "printed")) && (
                        <div className="d-flex justify-content-end pt-5 pb-3">
                            <button
                                type="button"
                                className="button-primary me-3"
                                onClick={handleShowPrintModal}
                            >
                                Print
                            </button>
                        </div>
                    )
                }
            </div>
            <div className="mb-3" />
            <Row>
                <Col lg={10} className="mt-3 mt-lg-0"></Col>
                <Col lg={2} className="mt-3 mt-lg-0">
                <div className="PO-filters">
                    <button
                        type="button"
                        className="primary-btn"
                        onClick={handleExport}
                    >
                        <span className="me-2">
                            <img
                                width={20}
                                height={20}
                                src={downloadIcon} alt=""
                            ></img>
                        </span>
                        Download
                    </button>
                </div>
            </Col>
            </Row>

            <div
                className="display-none  print-container px-3 py-2 "
                id="printablediv"
            >
                {
                    checkedPayroll.map((data, index) => {
                        return (
                            <>
                            <div className="print-item" key={index}>
                                <div className="text-end print-header d-flex flex-column">
                                    <span>PAYSLIP</span>
                                    <span className="text-uppercase">
                                        {Moment(data.disbursement_date).format("MMMM DD, yyyy")}
                                    </span>
                                </div>
                                <div className="d-flex justify-content-center py-1 mt-1">
                                    <h5 className="print-shop-header">
                                        TRIPLE K EXPRESSFOODS / 3K EXPRESSFOODS / CHK BUSINESS
                                        VENTURES CORP
                                    </h5>
                                </div>
                                <div className="d-flex justify-content-center py-1 mt-1">
                                    <h3 className="print-shop-header">{data.month}</h3>
                                </div>
            
                                <div className="print-body">
            
                                    <div className="d-flex mt-2 mb-2 justify-content-evenly">
                                        <div className="print-table mt-3 mx-5">
                                            {renderTable(data)}
                                        </div>
                                    </div>
            
                                    <div className="d-flex mt-2 justify-content-evenly">
                                        <div className="print-table ms-5 me-2 baseline">
                                            {renderTableDeductions(data)}
                                        </div>
                                        <div className="print-table me-5 ms-2 baseline">
                                            {renderTableEarnings(data)}
                                        </div>
                                    </div>
                                    <Row className="mt-2">
                                        <Col xs={6} className="print-sig justify-content-center d-flex">
                                            <img src={signature} className="print-logo" />
                                        </Col>
                                        <Col xs={6} className="print-sig justify-content-center d-flex">
                                        </Col>
                                    </Row>
                                    <Row className="mt-2 mb-5">
                                        <Col xs={6} className="print-sig justify-content-center d-flex">
                                            <Row className="print-sig justify-content-center gotham">
                                                APPROVERS NAME
                                                <div className="margin-underline"></div>
                                                Employer's Signature
                                            </Row>
                                        </Col>
                                        <Col xs={6} className="print-sig justify-content-center d-flex">
                                            <Row className="print-sig justify-content-center gotham">
                                                <div className="margin-underline"></div>
                                                Employee's Signature
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            </>
                        )
                    })
                }
            </div>

            {/* modals */}
            
            <CashAdvanceModal
                show={showPrintModal}
                hide={handleClosePrintModal}
                text="print this payroll"
                page="transaction"
                handler={handlePrintPI}
            />

            <Delete
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                text="payroll"
                onDelete={handleDeleteExpense}
                isClicked={isClicked}
            />

            <Modal show={showAddModal} onHide={handleCloseAddModal} size="lg" centered>
                <Modal.Body>
                    <span className="PI-modal-header">
                        ADD PAYROLL
                    </span>
                    <div className="PI-modal-body mt-3">
                        <Row>
                            <Col>
                                <span className="PI-modal-label ">EMPLOYEE TYPE</span>
                                <label className="badge-required">{` *`}</label>
                                <select
                                    className="nc-modal-custom-select"
                                    name="employee_type"
                                    onChange={(e) => handlePayrollChange(e)}
                                >
                                    <option value=""></option>
                                    <option value="service crew">Service Crew</option>
                                    <option value="office staff">Office Staff</option>
                                    <option value="department head">Department Head</option>
                                    <option value="driver">Driver</option>
                                    <option value="warehouse staff">Warehouse Staff</option>
                                    <option value="commissary staff">Commissary Staff</option>
                                </select>
                                <InputError
                                    isValid={isError.employee_type}
                                    message={"Type is required"}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Row>
                                    <span className="PI-modal-label ">DISBURSEMENT DATE</span>
                                </Row>
                                <Row>
                                    {/* {} */}
                                    <DatePicker
                                        autoComplete="off"
                                        selected={payrollDetails.disbursement_date ? payrollDetails.disbursement_date : new Date()}
                                        name="disbursement_date"
                                        placeholderText={"Select Date"}
                                        onChange={(date) => {
                                            setPayrollDetails((prev) => {
                                                return { ...prev, 
                                                    disbursement_date: date,
                                                };
                                            });
                                        }}
                                        fixedHeight
                                        className="PI-date-btn me-3 form-control"
                                        showYearDropdown
                                        dateFormat="MMM dd, yyyy"
                                        dateFormatCalendar="MMMM"
                                        yearDropdownItemNumber={20}
                                        scrollableYearDropdown
                                    />
                                    <InputError
                                        isValid={isError.disbursement_date}
                                        message={"Disbursement date from is required"}
                                    />
                                </Row>
                                {/* <Form.Control
                                    type="date"
                                    name="disbursement_date"
                                    className="nc-modal-custom-text"
                                    onChange={(e) => { handlePayrollChange(e) }}
                                /> */}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Row>
                                    <span className="PI-modal-label ">DATE FROM</span>
                                </Row>
                                <Row>
                                    <DatePicker
                                        autoComplete="off"
                                        selected={payrollDetails.date_from ? payrollDetails.date_from : new Date()}
                                        name="date_from"
                                        placeholderText={"Select Date"}
                                        onChange={(date) => {
                                            setPayrollDetails((prev) => {
                                                return { ...prev, 
                                                    date_from: date,
                                                };
                                            });
                                        }}
                                        fixedHeight
                                        className="PI-date-btn me-3 form-control"
                                        showYearDropdown
                                        dateFormat="MMM dd, yyyy"
                                        dateFormatCalendar="MMMM"
                                        yearDropdownItemNumber={20}
                                        scrollableYearDropdown
                                    />
                                    <InputError
                                        isValid={isError.date_from}
                                        message={"Date from is required"}
                                    />
                                </Row>
                                {/* <Form.Control
                                    type="date"
                                    name="date_from"
                                    className="nc-modal-custom-text"
                                    onChange={(e) => { handlePayrollChange(e) }}
                                /> */}
                            </Col>
                            <Col>
                                <Row>
                                    <span className="PI-modal-label ">DATE TO</span>
                                </Row>
                                <Row>
                                    <DatePicker
                                        autoComplete="off"
                                        selected={payrollDetails.date_to ? payrollDetails.date_to : new Date()}
                                        name="date_to"
                                        placeholderText={"Select Date"}
                                        onChange={(date) => {
                                            setPayrollDetails((prev) => {
                                                return { ...prev, 
                                                    date_to: date,
                                                };
                                            });
                                        }}
                                        fixedHeight
                                        className="PI-date-btn me-3 form-control"
                                        showYearDropdown
                                        dateFormat="MMM dd, yyyy"
                                        dateFormatCalendar="MMMM"
                                        yearDropdownItemNumber={20}
                                        scrollableYearDropdown
                                        minDate={payrollDetails.date_from ? payrollDetails.date_from : ""}
                                    />
                                    <InputError
                                        isValid={isError.date_to}
                                        message={"Date to is required"}
                                    />
                                </Row>
                                {/* <Form.Control
                                    type="date"
                                    name="date_to"
                                    className="nc-modal-custom-text"
                                    onChange={(e) => { handlePayrollChange(e) }}
                                /> */}
                            </Col>
                        </Row>
                    </div>
                    <div className="d-flex justify-content-end my-4 pt-1 d-flex-responsive">
                    <button
                        type="button"
                        onClick={handleCloseAddModal}
                        className="button-secondary me-2"
                    >
                        Close
                    </button>
                    <button
                        type="button"
                        onClick={fetchEmployees}
                        className="button-primary"
                    >
                        Continue
                    </button>
                    </div>
                </Modal.Body>
            </Modal>

            
            <Modal show={showEmployeeModal} onHide={handleCloseEmployeeModal} size="lg" centered>
                <Modal.Body>
                    <span className="PI-modal-header">
                        ADD PAYROLL
                    </span>
                    <div className="PI-modal-body mt-3">
                        <Row>
                            <Col>
                                <span className="PI-modal-label">EMPLOYEE NAMES</span>
                                <Select
                                    name="applicable_branches"
                                    className="nc-modal-custom-text"
                                    options={employeesWOutPayroll}
                                    value={selectedEmployees}
                                    onChange={setSelectedEmployees}
                                    placeholder={`Select Employees`}
                                    isMulti={true}
                                    isSearchable={true}
                                />
                                <InputError
                                    isValid={isError.employees}
                                    message={"Employee is required"}
                                />
                            </Col>
                        </Row>
                    </div>
                    <div className="d-flex justify-content-end my-4 pt-1 d-flex-responsive">
                    <button
                        type="button"
                        onClick={handleCloseEmployeeModal}
                        className="button-secondary me-3"
                    >
                        Back
                    </button>
                    <button
                        type="button"
                        onClick={handleAddModal}
                        className="button-primary"
                    >
                        Continue
                    </button>
                    </div>
                </Modal.Body>
            </Modal>
            <Footer/>
        </div> 
    );
}
